import { colors } from '@anyroad/theme';
type colorEnum =
  | 'destructive'
  | 'primary'
  | 'secondary'
  | 'subtle'
  | 'tertiary'
  | undefined;

export const handleBackgroundColor = (color: colorEnum) => {
  switch (color) {
    case 'destructive':
      return `${colors.error}`;
    case 'secondary':
      return 'transparent';
    case 'tertiary':
      return 'transparent';
    case 'subtle':
      return 'transparent';
    default:
      return `${colors.primary}`;
  }
};

export const handleBorderColor = (color: colorEnum) => {
  switch (color) {
    case 'destructive':
      return `${colors.error}`;
    case 'secondary':
      return `${colors.primary}`;
    case 'tertiary':
      return `${colors.error}`;
    case 'subtle':
      return `${colors.text.secondary}`;
    default:
      return `${colors.primary}`;
  }
};

export const handleColor = (color: colorEnum) => {
  switch (color) {
    case 'destructive':
      return `${colors.white}`;
    case 'secondary':
      return `${colors.primary}`;
    case 'tertiary':
      return `${colors.error}`;
    case 'subtle':
      return `${colors.text.secondary}`;
    default:
      return `${colors.white}`;
  }
};

export const handleHoverColor = (color: colorEnum) => {
  switch (color) {
    case 'destructive':
      return `${colors.error}`;
    case 'secondary':
      return '#f2f4f9';
    case 'tertiary':
      return '#f2f4f9';
    case 'subtle':
      return '#f2f4f9';
    default:
      return '#263dd6';
  }
};
